import { Repeat } from "lucide-react";
import { CARD } from "../lib/planner";

export const DailyHabits = ({ habits = [], completed = [], onToggle, title }) => {
  if (!habits.length) return null;
  const done = habits.filter((h) => completed.includes(h.id)).length;

  return (
    <div data-testid="daily-habits-card" className={`${CARD} p-6 sm:p-8`}>
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <Repeat className="h-5 w-5 text-stone-400" />
          <h2 className="font-heading text-2xl font-bold text-[#3b2a24] dark:text-stone-100">{title || "Daily essentials"}</h2>
        </div>
        <span data-testid="habit-count" className="text-sm font-semibold text-stone-400 dark:text-stone-500">
          {done}/{habits.length}
        </span>
      </div>
      <div className="space-y-1">
        {habits.map((h) => {
          const checked = completed.includes(h.id);
          return (
            <button
              key={h.id}
              type="button"
              data-testid={`habit-${h.id}`}
              onClick={() => onToggle(h.id)}
              className="w-full flex items-center gap-4 py-3 px-2 rounded-2xl hover:bg-stone-50 dark:hover:bg-stone-800 transition-colors text-left"
            >
              <span
                className={`h-6 w-6 rounded-full border-2 flex items-center justify-center transition-colors ${
                  checked ? "bg-stone-800 dark:bg-stone-100 border-stone-800 dark:border-stone-100" : "border-stone-200 dark:border-stone-700"
                }`}
              >
                {checked && <span className="text-stone-50 dark:text-stone-900 text-xs">✓</span>}
              </span>
              <span className={`text-base ${checked ? "text-[#3b2a24] dark:text-stone-100 line-through" : "text-stone-500 dark:text-stone-300"}`}>
                {h.content}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
